
import Vue from 'vue/types/umd';
<!-- Page that lists and manages avaliations -->
<template>
  <div>
    <!-- Page Title -->
    <page-title icon="fa fa-solid fa-clipboard" main="Avaliações" sub="Avaliação 360" :help="true" titleHelp="Página responsável pela listagem e gerenciamento das avaliações 360."
    content="Para alteração basta ir com o mouse em ações e clicar em Editar.
Para criação pressione o botão no canto superior direito 'Nova Avaliação'">
      <template v-slot:actions>
        <!-- v-if="$can('create', 'avaliation')" -->
        <base-button
          @click="openAvatiationFormModal()"
          type="neutral"
          class="ml-3"
          size="sm"
          >Nova Avaliação</base-button
        >
      </template>
    </page-title>

    <div class="card mt-2" style="padding: 1rem">
      <div slot="header" class="align-items-center">
        <div class="col-sm-12 col-md-12">
          <h5 class="h3 mb-0">Filtros</h5>
          <h6 class="text-uppercase text-muted ls-1 mb-4">
            CONFIGURE QUAIS DADOS DEVERÃO SER LISTADOS, EM SEGUIDA CLIQUE EM PESQUISAR PARA ATUALIZAR AS AVALLIAÇÕES
          </h6>
          <div class="row">
            <div class="col-12 col-sm-12 col-md-3">
              <label class="form-control-label d-block mb-3">Papéis</label>
              <multiselect
                v-loading="loading.role"
                v-model="filter.role"
                :options="roles || []"
                label="name"
                track-by="id"
                :allow-empty="true"
                :preserveSearch="true"
                :showNoResults="false"
                select-label=""
                deselect-label=""
                @select="getUsers(null, filter.role)"
                @remove="getUsers()"
                placeholder="Selecionar um papel"
                :selected-label="'Selecionado'">
              </multiselect>
            </div>
            <div class="col-12 col-sm-12 col-md-3">
              <label class="form-control-label d-block mb-3">Usuários</label>
              <multiselect
                v-loading="loading.users"
                v-model="filter.user"
                :options="users || []"
                label="name"
                track-by="id"
                :allow-empty="true"
                :preserveSearch="true"
                :showNoResults="false"
                select-label=""
                deselect-label=""
                placeholder="Selecionar um usuário"
                @search-change="getUsers"
                :selected-label="'Selecionado'">
              </multiselect>
            </div>
            <div class="col-12 col-sm-12 col-md-3">
              <base-input group class="mb-0 mt-2" label="Nome da avaliação">
                <input type="text" class="form-control" @keyup.enter="getAvaliations" v-model="filter.avaliation" placeholder="Informe o nome de uma avaliação" />
              </base-input>
            </div>
            <div class="col-12 col-sm-12 col-md-3 row mt-2">
              <div class="mt-4">
                <base-button outline type="success" id="button-addon2" v-on:click="getAvaliations" :loading="loading.avaliations">Pesquisar</base-button>
              </div>
              <div class="mt-4 ml-3">
                <base-button outline type="secondary" id="button-addon2" v-on:click="clean">Limpar</base-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Avaliation List -->
    <div class="card mt-2" style="padding: 1rem">
      <div class="border-0 card-header">
        <h3 class="mb-0">Avaliações:</h3>
      </div>

      <avaliation-list
        :avaliations="avaliations"
        :loading="loading.avaliations"
        @action:respond:avaliation="openAvatiationResponseFormModal($event)"
        @action:edit:avaliation="openAvatiationFormModal($event)"
        @action:destroy:avaliation="destroyAvaliation($event)"
        @action:show:avaliation="showAvaliation($event)"
      />

      <div class="card-footer py-4 d-flex justify-content-end">
        <base-pagination
          @input="getAvaliations"
          v-model="pagination.page"
          :total="pagination.count"
          :perPage="pagination.per_page"
        >
        </base-pagination>
      </div>
    </div>

    <!-- Modals and Dialogs -->
    <modal :show.sync="modals.avaliationForm" id="avaliation-form" size="lg">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">{{ avaliationFormData.id ? 'Editar' : 'Nova' }} Avaliação</h5>
      </template>
      <form role="form" @submit.prevent="saveAvaliation">
        <avaliation-form ref="avaliationFormRef" v-model="avaliationFormData" :errors.sync="errors" />
      </form>
      <template slot="footer">
        <base-button type="secondary" @click="closeAvaliationFormModal">Fechar</base-button>
        <base-button type="success" @click="saveAvaliation" :disabled="savingAvaliation" v-loading="savingAvaliation">Salvar</base-button>
      </template>
    </modal>

    <modal :show.sync="modals.avaliationResponseForm" id="avaliation-response-form" size="lg">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Responder Avaliação</h5>
      </template>
      <form role="form" @submit.prevent="saveAvaliationResponse">
        <avaliation-response-form :avaliation="avaliationFormData" v-model="avaliationResponseFormData" :errors="errors" />
      </form>
      <template slot="footer">
        <base-button type="secondary" @click="closeAvaliationResponseFormModal">Fechar</base-button>
        <base-button type="success"   @click="saveAvaliationResponse" :disabled="savingAvaliationResponse" v-loading="savingAvaliationResponse">Enviar Resposta</base-button>
      </template>
    </modal>
  </div>
</template>

<script>
import PageTitle from "@/layouts/PageTitle";
import AvaliationResponseForm from "../../components/Avaliation/AvaliationResponseForm.vue";
import AvaliationForm from "../../components/Avaliation/AvaliationForm.vue";
import AvaliationList from "@/components/Avaliation/AvaliationList.vue";
import swal from 'sweetalert2'
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";

export default {
  name: 'ListAvaliations',
  components: {
    PageTitle,
    AvaliationList,
    AvaliationForm,
    AvaliationResponseForm,
    Multiselect
  },
  data: () => ({
    avaliations: [],
    lastAvaliationRequest: 1,
    avaliationFormData: {},
    avaliationResponseFormData: [],
    savingAvaliation: false,
    savingAvaliationResponse: false,
    errors: {},
    pagination: {
      page: 1,
      per_page: 10,
      count: 0,
    },
    modals: {
      avaliationForm: false,
      avaliationResponseForm: false,
    },
    filter: {
      role: {},
      user: {},
      avaliation: ''
    },
    loading: {
      avaliations: false,
      roles: false,
      users: false
    },
    roles: [],
    users: [],
  }),
  mounted() {
    this.getAvaliations();
    this.getRoles();
    this.getUsers();
  },
  methods: {
    showAvaliation(avaliation) {
      this.$router.push({ name: 'Respostas de Avaliações', params: { avaliationId: avaliation.id } });
    },
    async getAvaliations() {
      this.loading.avaliations = true;
      const currentAvaliationRequest = ++this.lastAvaliationRequest;

      const queryData = { avaliation_type: this.avaliationType }

      if (this.filter && this.filter.avaliation)  queryData.name    = this.filter.avaliation;
      if (this.filter && this.filter.user)        queryData.user_id = this.filter.user.id;
      if (this.filter && this.filter.role)        queryData.role_id = this.filter.role.id;

      try {
        const response = await this.$http.secured.get('/api/v1/avaliations', {
          params: {
            ...this.pagination,
            q: queryData
          },
        });

        if (currentAvaliationRequest !== this.lastAvaliationRequest) return;

        this.avaliations         = response.data.avaliations;
        this.pagination.page     = response.data.page     || 1;
        this.pagination.per_page = response.data.per_page || 10;
        this.pagination.count    = response.data.count    || 0;

        this.lastAvaliationRequest = currentAvaliationRequest;
      } catch (error) {
        this.$store.dispatch('snackbar/showError', error);
      }
      this.loading.avaliations = false;
    },
    async getRoles() {
      this.loading.roles = true;
      try {
        const { data } = await this.$http.secured.get('/api/v1/roles', { params: { per_page: 100 } });
        this.roles = data.roles || [];
      } catch (error) {
        console.error("[AvaliationForm][getRoles] Error: ", error)
      }
      this.loading.roles = false;
    },
    async getUsers(query = null, role) {
      this.loading.users = true;

      const queryData = { name: query }
      if (role) queryData.role_id = role.id;

      try {
        const { data } = await this.$http.secured.get('/api/v1/users', {
          params: {
            per_page: 10,
            q: queryData
          }
        });
        this.users = data.users || [];
      } catch (error) {
        console.error("[AvaliationForm][getUsers] Error: ", error)
      }
      this.loading.users = false;
    },
    openAvatiationResponseFormModal(avaliation){
      this.avaliationFormData = avaliation || {};
      this.errors = {};
      this.modals.avaliationResponseForm = true;
    },
    async openAvatiationFormModal(avaliation){
      if (avaliation && avaliation.response_count) {
        const result = await swal.fire({
          title: `Deseja editar a avaliação ${ avaliation.name }?`,
          text: `Essa ação não poderá ser desfeita e pode afetar as respostas já enviadas.`,
          showCancelButton: true,
          confirmButtonColor: '#F5365C',
          cancelButtonColor: '#8898aa',
          confirmButtonText: 'Continuar',
          cancelButtonText: 'Voltar',
        })

        if (!result.isConfirmed) {
          return
        }
      }

      this.avaliationFormData = avaliation || {};
      this.errors = {};
      this.modals.avaliationForm = true;
    },
    closeAvaliationFormModal(){
      this.avaliationFormData = {};
      this.errors = {};
      this.modals.avaliationForm = false;
    },
    closeAvaliationResponseFormModal() {
      this.avaliationFormData = {};
      this.errors = {};
      this.modals.avaliationResponseForm = false;
    },
    clean() {
      this.filter = {};
      this.getAvaliations();
    },
    validateAvaliationItemsPresence() {
      return this.avaliationFormData.avaliation_items && this.avaliationFormData.avaliation_items.length > 0;
    },
    async saveAvaliation() {
      this.savingAvaliation = true;

      this.$refs.avaliationFormRef.validateFields();

      if (!this.validateAvaliationItemsPresence()) {
        this.savingAvaliation = false;
        this.$toasted.global.defaultError({ msg: 'A avaliação deve conter pelo menos uma pergunta' });
        return;
      }

      try {
        if (this.avaliationFormData.id && (!this.avaliationFormData.user_ids && !this.avaliationFormData.role_ids)) {
          await this.updateAvaliation();
        } else {
          await this.createAvaliation();
        }
      } catch (error) {
        this.$toasted.global.defaultError({ msg: 'Erro ao salvar a avaliação. Tente novamente.' });
      } finally {
        this.savingAvaliation = false;
      }
    },
    async createAvaliation(){
      try {
        await this.$http.secured.post('/api/v1/avaliations', {
          avaliation: {
            ...this.avaliationFormData,
            avaliation_type: this.avaliationType
          },
        });

        this.$toasted.global.defaultSuccess({msg: 'Avaliação criada com sucesso!'});
        this.closeAvaliationFormModal();
        this.getAvaliations();
      } catch (error) {
        console.error('[ListAvaliations][createAvaliation]', error);
        this.errors = error.response.data;
        // this.$toasted.global.defaultError()
      }
    },
    async updateAvaliation(){
      try {
        await this.$http.secured.put(`/api/v1/avaliations/${this.avaliationFormData.id}`, {
          avaliation: {
            ...this.avaliationFormData,
            avaliation_type: this.avaliationType
          },
        });

        this.$toasted.global.defaultSuccess({msg: 'Avaliação atualizada com sucesso!'});
        this.closeAvaliationFormModal();
        this.getAvaliations();
      } catch (error) {
        console.error('[ListAvaliations][updateAvaliation]', error);
        this.errors = error.response.data;
        // this.$toasted.global.defaultError()
      }
    },
    async destroyAvaliation(avaliation){
      const result = await swal.fire({
        title: `Excluir avaliação ${ avaliation.name }?`,
        text: `Essa ação não poderá ser desfeita.`,
        showCancelButton: true,
        confirmButtonColor: '#F5365C',
        cancelButtonColor: '#8898aa',
        confirmButtonText: 'Excluir',
        cancelButtonText: 'Voltar',
      })

      if (!result.isConfirmed) {
        return
      }

      try {
        await this.$http.secured.delete(`/api/v1/avaliations/${avaliation.id}`);

        this.$toasted.global.defaultSuccess({msg: 'Avaliação excluída com sucesso!'});
        this.getAvaliations();
      } catch (error) {
        console.error('[ListAvaliations][destroyAvaliation]', error);
        this.$toasted.global.defaultError({msg: 'Não foi possível excluir a avaliação.'})
      }
    },
    async saveAvaliationResponse(){
      this.savingAvaliationResponse = true;

      try {
        await this.$http.secured.post(`/api/v1/avaliations/${this.avaliationFormData.id}/send_responses`, {
          avaliation_responses: this.avaliationResponseFormData,
        });

        this.$toasted.global.defaultSuccess({msg: 'Resposta enviada com sucesso!'});
        this.closeAvaliationResponseFormModal();
        this.getAvaliations();
      } catch (error) {
        console.error('[ListAvaliations][saveAvaliationResponse]', error);
        this.errors = error.response.data;
        // this.$toasted.global.defaultError()
      }

      this.savingAvaliationResponse = false;
    },
  },
  computed: {
    avaliationType() {
      return this.$route.meta.avaliationType;
    },
  },
}
</script>
